import { useQuery } from '@tanstack/react-query';
import { getAllPlants } from '../service/plants';
import { tokenManager } from '../api/tokenManager';

export const usePlants = () => {
  const isAuthenticated = !!tokenManager.get('accessToken');

  return useQuery({
    queryKey: ['plants'],
    queryFn: getAllPlants,
    enabled: isAuthenticated,
  });
};
